





























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';

import { IMaintenance } from '@/models';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Vue.extend({
  name: 'MaintenanceBanner',

  components: { ErrorAlert },

  data: () => ({
    loading: false,
    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    ...mapGetters({
      getNearestMaintenance: 'maintenance/getNearestMaintenance'
    }),

    maintenance(): IMaintenance | undefined {
      return this.getNearestMaintenance;
    },

    color(): string {
      return this.maintenance?.isUnderMaintenance ? 'error' : 'warning';
    }
  },

  methods: {
    ...mapActions({
      fetchMaintenances: 'maintenance/fetchMaintenances'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  },

  mounted() {
    const startDate = moment(Date.now())
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');
    const endDate = moment(Date.now())
      .utc()
      .add(1, 'weeks')
      .format('YYYY-MM-DDTHH:mm:ss');
    this.loading = true;
    this.fetchMaintenances({
      start: startDate,
      end: endDate
    })
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);

        if (error.response && error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
});
